'use client';
import React from 'react';
import { Box, Stack } from '@mui/material';
import Image from 'next/image';
import { Mobile } from '@components/Mobile';
import { Desktop } from '@components/Desktop';
import CommonContainer from '@components/CommonContainer';
import ReactHtmlParser from '@libs/reactHtmlParser';
import ParallaxText from '@components/ParallaxText';
import ParallaxBlock from '@components/ParallaxBlock';
import cn from './style.module.scss';
export default function HouseArchitecture(props: any) {
  const { t } = props;
  return (
    <Stack component="section" className={cn.beachHouseArchitecture}>
      <Box
        className={cn.beachArchitectTopGraphics}
        sx={{
          backgroundImage: `url(${props.beachHouseArchitectTopImage.url})`,
        }}
      />
      <CommonContainer maxWidth={{ xs: '100%', md: '1320px' }} flexGrow={1}>
        <Box className={cn.beachArchitectureInner}>
          <Box className={cn.beachArchitectureTheme}>
            <ParallaxBlock animationType="zoomIn" animationDuration={500}>
              <Mobile>
                <Image
                  src={props.houseArchitectureMobileBanner.url}
                  alt="House Architecture Mobile Banner"
                  width={768}
                  height={768}
                  unoptimized
                  quality={100}
                />
              </Mobile>
              <Desktop>
                <Image
                  src={props.houseArchitectureDesktopBanner.url}
                  alt="House Architecture Desktop Banner"
                  width={768}
                  height={768}
                  unoptimized
                  quality={100}
                />
              </Desktop>
            </ParallaxBlock>
          </Box>
          <Box className={cn.beachArchitectureBody}>
            <Box className={cn.beachArchitectureContent}>
              <Box className={cn.beachArchitectureContent__heading}>
                <ParallaxText
                  variant="h2"
                  animationType="slideInBottom"
                  animationDuration={500}
                >
                  {ReactHtmlParser(t['beachHouseArchitectureHeading'])}
                </ParallaxText>
              </Box>
              <Box className={cn.beachArchitectureContent__description}>
                <ParallaxText
                  variant="p"
                  animationType="slideInBottom"
                  animationDuration={500}
                >
                  {ReactHtmlParser(t['beachHouseArchitectureContent'])}
                </ParallaxText>
              </Box>
            </Box>
          </Box>
        </Box>
      </CommonContainer>
    </Stack>
  );
}
